export const dialogActions = [
    {'text': 'CANCEL', 'action': 'cancel', 'status': 'enabled'},
    {'text': 'Save', 'action': 'save', 'status': 'enabled'},
]

export function formatDate (date) {
    if (!date) return null

    let [year, month, day] = date.split('-')
    if(day < 10) {
        day = day.slice(1,2)
    } 
    if(month < 10) {
        month = month.slice(1,2)
    }
    return `${year}-${month}-${day}`
}

export function downloadFile(fileUrl, fileName="sample.pdf") {
    let link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target="_blank"
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));  
}

export const timelineGraphColors = {
    'pii': "96,106,133",
    'emails': "173,159,98",
    'passwords': "68,138,158",
    'usernames': "178,87,171"
}

export function generateRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    var color = '#';
    for (var i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random()  * 16)];
    }
    return color;
}

export const filterByDateOptions = {
    '24h':'24h',
    '1w':'1 Week',
    '1m':'1 Month',
    '3m':'3 Months',
    '6m':'6 Months',
    '1y':'1 year',
    'custom':'Custom'
}

export function prepareFilterParams(filterOptions) {
    let params = {};
    let option = filterOptions.selectedOption;
    let fromDate = formatDate(filterOptions.fromDate);
    let toDate = formatDate(filterOptions.toDate);
    if (option && option !== 'custom') {
        params['date_range'] = option;
    }
    if (fromDate && toDate) {
        params['from'] = fromDate;
        params['to'] = toDate;
    }
    return params;
}

export function mmddYYYYFormat(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${month}/${day}/${year}`
}

export function getMaxDate(dates) {
    /*
        Args: List of dates
        returned date format: YYYY-MM-DD
    */
    let datesList = dates;
    var formattedDates = datesList.map(function(val){
        return new Date(val);
    });
    let maxDate = new Date(Math.max(...formattedDates)).toISOString().substr(0,10);
    return maxDate;
}

export function dateFormatWithHours() {
    /*
        Return format: DD MMM, YY HH:MM
        Example: 07 Jul, 21 16:21
    */
    let date = new Date(new Date()).toLocaleDateString('default', {day: '2-digit',month:'short', year:'2-digit'}).replaceAll('-',' ');
    let hours = new Date().getHours();
    let min = new Date().getMinutes();
    let [day, month, year] = date ? date.replaceAll(',', '').split(' ') : new Array(3).fill('-');
    let fD = day + ' ' + month + ', ' + year + ' ' + hours + ':' + min + 'h';
    return fD
}

export function getPastDates(dates, toDate) {
    /*
        Return dates less than toDate
    */
    if (toDate) {
        return dates < toDate
    } else {
        return dates
    }
}

export function getFutureDates(dates, fromDate) {
    /*
        Return dates greater than fromdate
    */
    if (fromDate) {
        return dates > fromDate
    } else {
        return dates
    }
}

export function shortendDateFormat(date, time) {
    // time - Boolean value
    // Date format ex: "2017-04-01T00:00:00Z"
    if (date) {
        let givenDate = new Date(date);
        let modifiedDate = givenDate.toLocaleDateString('default', {day: '2-digit',month:'short', year:'numeric'});
        if (time) {
            let dateTime = givenDate.toISOString().substring(11, 19);
            return modifiedDate + ' ' + dateTime
        } else {
            return modifiedDate
        }
    }  else {
        return date
    }
}